

export const no_padding = { paddingTop: 0 ,paddingBottom:0}
export const number_style = { direction: 'ltr' }
export const mergeStyles = (s1,s2): any => {

}
